import z from '@/lib/zod';
import { SKIP, TAKE } from '@/lib/constants/pagination';

/**
 * Testo di ricerca: un link scritto a mano con `?search=123` arriva dal router
 * come numero e senza conversione la route andrebbe in errore.
 */
export const searchTextParam = z.preprocess(
  (value) => (typeof value === 'number' ? String(value) : value),
  z.string().nullish()
);

export const commonSearchSchema = z.object({
  search: searchTextParam,
  skip: z.number().nullish().default(SKIP),
  take: z.number().nullish().default(TAKE),
  sort: z.any().nullish(), // Axios client will handle stringification
  show: z.string().nullish(), // ID of entity to show in sheet
  tab: z.string().nullish(), // for tab selection in multi-tab pages
});

export type CommonSearchSchemaInput = z.infer<typeof commonSearchSchema>;
